export default __webpack_public_path__ + "static/media/meetings.4e90ecbc.svg";